import "../../sass/core.sass";

import { ApolloProvider } from "@apollo/client";
import client from "../helpers/apollo-client";

import { Switch } from "react-router";
import { Router, Route } from "react-router-dom";
import history from "../helpers/history";
import { Provider } from "react-redux";
import React from "react";
import DownloadHistory from "../components/download-history";
import InvoiceList from "../components/invoice-list";
import InvoiceEdit from "../components/invoice-edit";
import InfiniteDeniedUploads from "../components/dashboard/inactive-uploads/infinite-denied-uploads";
import InfinitePendingUploads from "../components/dashboard/inactive-uploads/infinite-pending-uploads";
import InfiniteCollections from "../components/dashboard/collections/infinite-collections";
import SignupPage from "../components/auth/signup/signup-page";
import Modal from "./modal";
import Toasts from "./toasts";
import PrepaidBalancePage from "../components/PrepaidBalancePage/index";

import { LegacyUserContextProvider } from "contexts/CurrentUserContext";

import store from "../stores/reduxStore";

class NounProject extends React.Component {
    constructor(props) {
        super(props);

        if (props.args) {
            window._nounConfig.args = props.args;
        }
    }

    render() {
        const SignupPageComponent = () => {
            const { signupType, plans, next } = this.props.args;
            return (
                <SignupPage signupType={signupType} plans={plans} next={next} />
            );
        };

        let { args } = this.props;

        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <LegacyUserContextProvider>
                        <div style={{ width: "100%" }}>
                            <Router history={history}>
                                <Switch>
                                    <Route
                                        exact
                                        path="/accounts/signup/"
                                        component={SignupPageComponent}
                                    />
                                    <Route
                                        exact
                                        path="/accounts/signup/:signupType/"
                                        component={SignupPageComponent}
                                    />
                                    <Route
                                        exact
                                        path="/:username/settings/invoices/:chargeId/edit/"
                                        component={InvoiceEdit}
                                    />
                                    <Route
                                        exact
                                        path="/:username/settings/invoices/:chargeId?/"
                                        component={InvoiceList}
                                    />
                                    <Route
                                        exact
                                        path="/:username/settings/invoices/"
                                        component={InvoiceList}
                                    />
                                    <Route
                                        exact
                                        path="/:username/settings/icon-history/"
                                        component={DownloadHistory}
                                    />
                                    <Route
                                        exact
                                        path="/:username/uploads/denied/"
                                        component={InfiniteDeniedUploads}
                                    />
                                    <Route
                                        exact
                                        path="/:username/uploads/pending/"
                                        component={InfinitePendingUploads}
                                    />
                                    <Route
                                        exact
                                        path="/:username/collections/"
                                        component={() => (
                                            <InfiniteCollections
                                                args={this.props.args}
                                            />
                                        )}
                                    />
                                    <Route
                                        exact
                                        path="/:username/settings/prepaid-balance"
                                        component={PrepaidBalancePage}
                                    />
                                </Switch>
                                <Modal />
                            </Router>
                            <Toasts />
                        </div>
                    </LegacyUserContextProvider>
                </Provider>
            </ApolloProvider>
        );
    }
}

export default NounProject;
